package com.eladfinish.bible.contest.screens.main.pastQuizzesSheet

import com.eladfinish.bible.contest.analytics.AnalyticsConstants

/** Where "חידונים אמיתיים" was opened from, to compare the button with the sheet. */
enum class PastQuizzesSource(val analyticsValue: String) {
    HOME_BUTTON(AnalyticsConstants.PastQuizzes.SOURCE_HOME_BUTTON),
    WHATS_NEW_SHEET(AnalyticsConstants.PastQuizzes.SOURCE_WHATS_NEW_SHEET),
}

internal fun pastQuizzesOpenedParams(inApp: Boolean, source: PastQuizzesSource): Map<String, Any> = mapOf(
    AnalyticsConstants.PastQuizzes.PARAM_SURFACE to
        if (inApp) AnalyticsConstants.PastQuizzes.SURFACE_WEBVIEW else AnalyticsConstants.PastQuizzes.SURFACE_BROWSER,
    AnalyticsConstants.PastQuizzes.PARAM_SOURCE to source.analyticsValue,
)
